export const instructionQueryKeys = {
  listInstructions: 'instructions',
  listInstructionVersions: 'instruction-versions',
  getInstructionVersion: 'instruction-version',
  listInstructionLanguages: 'instruction-languages',
  listInstructionVersionLanguages: 'instruction-version-languages',
  listSegments: 'instruction-segments',
  getSegment: 'instruction-segment',
  listSteps: 'instruction-steps',
  listStepNotices: 'instruction-step-notices',
  getAnimation: 'instruction-animation',
} as const;
